<template>
    <div>
        <c-form-element
            :label="'Soort vertaling'"
            :horizontal="true">
            <c-radio v-model="is_beedigd"
                :name="'type'"
                :options="[
                    {label:'Beëdigd', value: 1},
                    {label:'Regulier', value:0}
                ]"></c-radio>
        </c-form-element>

        <c-form-element
            :label="'Brontaal'"
            :horizontal="true"
            :clean="true">
            <c-select
                :options="languages"
                :required="true"
                :searchable="true"
                :name="'source'"
                v-model="brontaal"></c-select>
        </c-form-element>

        <c-form-element
            :label="'Doeltaal'"
            :horizontal="true"
            :clean="true">
            <c-select
                :options="languages"
                :required="true"
                :searchable="true"
                :name="'target'"
                :multiple="true"
                v-model="doeltaal">
            </c-select>
        </c-form-element>

        <c-form-element
            :label="'Specialisatie'"
            :horizontal="true">
            <select v-model="specialisatie" :name="'specialization'">
                <option value=''></option>
                <option v-for="key in Object.keys(specializations)" :value='key' :key="'specialization-' + key">{{specializations[key]}}</option>
            </select>
        </c-form-element>

        <c-form-element
            :label="'Brondocument'"
            :helptext="(edit) ? 'Breid de bestaande bestanden uit met nieuwe bestanden' : ''"
            :horizontal="true">
            <c-upload
                v-model="bronbestanden"
                :name="'source-files'"
                :required="edit == undefined"
                :title="'Voeg bestanden toe'">
            </c-upload>
        </c-form-element>

        <c-form-element
            :label="'Referentiematriaal'"
            :helptext="(edit) ? 'Breid de bestaande bestanden uit met nieuwe bestanden' : ''"
            :horizontal="true">
            <c-upload
                v-model="referentiemateriaal"
                :name="'ref-files'"
                :title="'Voeg bestanden toe'">
            </c-upload>
        </c-form-element>

        <c-form-element
            :label="'Anoniem'"
            :horizontal="true">
            <c-radio v-model="is_anoniem" :name="'anonymous'" :options="[
                {label:'Ja', value:'1'},
                {label:'Nee', value:'0'}
                ]"></c-radio>
        </c-form-element>

        <c-form-element
            :label="'Urgentie'"
            :horizontal="true">
            <c-radio :required="true" :name="'urgency-applicant'" v-model="is_urgent" :options="[
                {label:'Laag', value:0},
                {label:'Hoog', value:1}
                ]"></c-radio>
        </c-form-element>

        <template v-if="user.is_planner">
            <c-form-element
                :label="'Spoed'"
                :horizontal="true">
                <c-radio :required="true" :name="'urgency-planner'" v-model="is_spoed" :options="[
                    {label:'Regulier', value:0},
                    {label:'Spoed', value:1}
                    ]"></c-radio>
            </c-form-element>

            <c-form-element
                v-show="is_spoed == 1"
                :label="'Spoedtarief'"
                :horizontal="true">
                <input type="number" v-model="spoedtarief" step="0.01" :required="is_spoed == 1" name="express-rate"/>
            </c-form-element>
        </template>

        <c-form-element
            :label="'Administratief kenmerk'"
            :horizontal="true">
            <input type="text" v-model="kenmerk" required name="characteristic"/>
        </c-form-element>

        <c-form-element
            :label="'Deadline'"
            :horizontal="true">
            <c-datepicker v-model="deadline" required name="deadline"></c-datepicker>
            <c-timepicker class="margin-t-16" :name="'deadline-time'" :required="true"  v-model="deadline_tijd"></c-timepicker>
        </c-form-element>

        <c-form-element
            :label="'Opmerking en instructies'"
            :horizontal="true">
            <c-textarea v-model="instructies" :name="'remark'"></c-textarea>
        </c-form-element>
    </div>
</template>

<script>
import Form from '@mixins/Form';
import { mapState } from 'vuex';

export default {
    mixins: [ Form ],
    props: {
        edit: {
            required: false
        }
    },
    data() {
        return {
            is_beedigd: 0,
            brontaal: '',
            doeltaal: '',
            specialisatie: '',
            is_anoniem: 0,
            is_urgent: 0,
            is_spoed: 0,
            spoedtarief: 0,
            kenmerk: '',
            deadline: '',
            deadline_tijd: '',
            instructies: '',
            bronbestanden: [],
            referentiemateriaal: []
        }
    },
    computed: {
        ...mapState({
            languages: state => state.preferences.data.translationLanguages,
            specializations: state => (state.preferences.data.specializations ?? {}),
            user: state => state.user.data,
        })
    }
}
</script>
